import React from 'react';
import { SparklesIcon } from './Icons';
import { UI_CONFIG } from '../../config';

const CREDIT = UI_CONFIG.CREDIT_LABEL || 'Tín dụng';

interface OutOfCreditsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigateToStore: () => void;
}

const OutOfCreditsModal: React.FC<OutOfCreditsModalProps> = ({ isOpen, onClose, onNavigateToStore }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60" onClick={onClose} aria-modal="true" role="dialog">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md m-4 flex flex-col" onClick={e => e.stopPropagation()}>
        <div className="p-8 text-center">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100">
                <SparklesIcon className="h-7 w-7 text-yellow-600" />
            </div>
            <h3 className="mt-5 text-xl font-bold text-gray-900">Bạn đã hết {CREDIT}!</h3>
            <p className="mt-2 text-sm text-gray-600">
                Để tiếp tục sử dụng tính năng này và các công cụ AI khác, vui lòng nạp thêm {CREDIT.toLowerCase()} vào tài khoản của bạn.
            </p>
        </div>
        <div className="bg-gray-50 px-6 py-4 flex flex-col-reverse sm:flex-row-reverse gap-3 rounded-b-xl">
          <button
            type="button"
            onClick={onNavigateToStore}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-teal-600 text-base font-medium text-white hover:bg-teal-700 sm:text-sm"
          >
            Mua {CREDIT}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:text-sm"
          >
            Để sau
          </button>
        </div>
      </div>
    </div>
  );
};

export default OutOfCreditsModal;
